import baseRoute from '../../fieldReport/baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/reports/virtual/findOrCreateGroupCode`;

export const ROUTE: RouteDefinition = `${baseRoute}/reports/virtual/findOrCreateGroupCode`;

export const URL = (): RouteDefinition => `${baseRoute}/reports/virtual/findOrCreateGroupCode`;
